// import hooks
import { useTranslation } from "react-i18next";

// import components
import { Container } from "react-bootstrap";
import Carousel from "react-multi-carousel";

// import assets
import { redHeart, heart, blueCart, cart } from "../../utils/cards-svgs";

import "react-multi-carousel/lib/styles.css";
import "../../assets/css/cards.css";

const CardList3 = ({ list }) => {
    const [t] = useTranslation("global");
    const responsive = {
        desktop: {
            breakpoint: {
                max: 3000,
                min: 1024
            },
            items: 2,
            partialVisibilityGutter: 40
        },
        mobile: {
            breakpoint: {
                max: 576,
                min: 0
            },
            items: 1
        },
        tablet: {
            breakpoint: {
                max: 1024,
                min: 576
            },
            items: 2,
            partialVisibilityGutter: 30
        }
    };
    return (
        <Container className="main-container card3-list-container">
            <h1 className="card-list-header">{list.title}</h1>
            <Carousel
                additionalTransfrom={0}
                arrows
                autoPlaySpeed={3000}
                centerMode={true}
                className=""
                containerClass="container"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite={false}
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={responsive}
                rewind={false}
                rewindWithAnimation={false}
                rtl={true}
                shouldResetAutoplay
                showDots
                sliderClass=""
                slidesToSlide={1}
                swipeable
            >
                {list.items.map((i) => (
                    <div className="card3">
                        <img
                            src={i.img}
                            alt="card image"
                            className="card3-img"
                        />
                        <div className="card3-overlay-div"></div>
                        <div className="card3-data">
                            <h3 className="card3-h">{i.title}</h3>
                            <a href={i.link} className="card1-link">
                                <span>{i.linkTxt}</span>
                                <div className="arrow-svg"></div>
                            </a>
                            <div className="card3-circles-div">
                                <div className="card1-circle">
                                    <div className="card-svg-circle">
                                        {i.wishList ? (
                                            <img
                                                src={redHeart}
                                                alt="wish list"
                                                className="card-svg-img"
                                            />
                                        ) : (
                                            <img
                                                src={heart}
                                                alt="wish list"
                                                className="card-svg-img"
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="card1-circle">
                                    <div className="card-svg-circle">
                                        {i.cart ? (
                                            <img
                                                src={blueCart}
                                                alt="cart"
                                                className="card-svg-img"
                                            />
                                        ) : (
                                            <img
                                                src={cart}
                                                alt="cart"
                                                className="card-svg-img"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                {list.viewMore && (
                    <div className="card3">
                        <div className="view-more-card-div">
                            <a href={list.viewMore} className="card1-link">
                                <span>{t("main.view-more")}</span>
                                <div className="arrow-svg"></div>
                            </a>
                        </div>
                    </div>
                )}
            </Carousel>
        </Container>
    );
};

export default CardList3;
